var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @packageDocumentation
 * @module      PopoverLabelAdditionalLine.ts
 * @description Encapsulates an additional label line for a Shui popover.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
import { LitElement, html, customElement, css } from 'lit-element';
/**
 * Functions as an additional line of the label (title) of an sh-popover.
 * This control should be the first child of the sh-popover's unnamed slot.
 * @noInheritDoc
 */
let PopoverLabelAdditionalLine = class PopoverLabelAdditionalLine extends LitElement {
    static get styles() {
        return css `
          sh-text {
            display: block;
            margin: -12px 0 12px 0;
          }
        `;
    }
    ;
    render() {
        return html `
            <sh-text size="body-2">
                <slot></slot>
            </sh-text>
        `;
    }
};
PopoverLabelAdditionalLine = __decorate([
    customElement('popover-label-additional-line')
], PopoverLabelAdditionalLine);
export { PopoverLabelAdditionalLine };
//# sourceMappingURL=PopoverLabelAdditionalLine.js.map